import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { DestroyRef, inject, Inject, Injectable, Optional, PLATFORM_ID, signal } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { BehaviorSubject, Observable } from 'rxjs';
import { MEDIA_TOKEN } from '../../../tockens';
@Injectable(
    { providedIn: 'root' }
)
export class MediaService {
    media = signal<string>('lg');
    deskmode = signal<boolean>(true);
    destroyRef = inject(DestroyRef);
    private mediachange: BehaviorSubject<string>;

    constructor(
        protected mediaObserver: BreakpointObserver,
        @Optional() @Inject(MEDIA_TOKEN) private media_token: string,
        @Inject(PLATFORM_ID) protected platformId: any,
    ) {
        this.media.set(this.media_token);
        this.deskmode.set(this.media_token !== 'xs');
        this.mediachange = new BehaviorSubject(this.media_token);
        this.initMedia();
    }

    initMedia(): void {
        this.mediaObserver
            .observe([Breakpoints.XSmall, Breakpoints.Small, Breakpoints.Medium, Breakpoints.Large, Breakpoints.XLarge]).pipe(
                takeUntilDestroyed(this.destroyRef)
            )
            .subscribe(() => {
                if (this.mediaObserver.isMatched(Breakpoints.XSmall)) {
                    this.media.set('xs');
                    this.deskmode.set(false);
                } else if (this.mediaObserver.isMatched(Breakpoints.Small)) {
                    this.media.set('sm');
                    this.deskmode.set(false);
                } else if (this.mediaObserver.isMatched(Breakpoints.Medium)) {
                    this.media.set('md');
                    this.deskmode.set(false);
                } else if (this.mediaObserver.isMatched(Breakpoints.Large)) {
                    this.media.set('lg');
                    this.deskmode.set(true);
                } else if (this.mediaObserver.isMatched(Breakpoints.XLarge)) {
                    this.deskmode.set(true);
                    this.media.set('xl');
                }

                this.mediachange.next(this.media());
            });
    }

    mediachange$(): Observable<string> {
        return this.mediachange.asObservable();
    }
}
